var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasDeactivatedShared(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277.11,
    height: 398.55,
    viewBox: "-106 0 207.84 298.91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.269 -.39407)",
    strokeWidth: 0.60406
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.683 273.54h-77.241c-10.063 0-19.465 2.6545-27.588-1.7423v12.048c0 8.5406 7.4121 15.462 16.553 15.462h99.309c9.1431 0 16.553-6.9214 16.553-15.462v-12.048c-8.1226 4.3969-17.522 1.7423-27.585 1.7423z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.165 0.39407h-66.208c-6.0864 0.015964-11.016 4.6227-11.033 10.308v56.947c1.8213-0.15508 3.6401-0.2577 5.5176-0.2577h77.241c1.875 0 3.6963 0.10262 5.5176 0.2577v-56.947c-0.01953-5.6854-4.9487-10.292-11.035-10.308zm-11.035 36.076c0 2.8461-2.4707 5.154-5.5176 5.154h-33.103c-3.0469 0-5.5176-2.3079-5.5176-5.154v-10.308c0-2.8461 2.4707-5.154 5.5176-5.154h33.103c3.0469 0 5.5176 2.3079 5.5176 5.154z",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-40.558 62.238h77.241c30.471 0 55.171 23.075 55.171 51.538v113.38c0 28.463-24.7 51.538-55.171 51.538h-77.241c-30.471 0-55.173-23.074-55.173-51.538v-113.38c0-28.463 24.702-51.538 55.173-51.538z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-1.9378 232.31c-11.035 0-44.138-1.9544-44.138-31.278 0.49805-9.674 5.0562-18.776 12.688-25.332 0.10254-0.0867 0.25635-0.10262 0.37598-0.0365 0.11963 0.0661 0.17822 0.20069 0.14404 0.32612-1.1816 3.227-3.9502 13.312 8.8281 13.312 4.4141 0 8.8257-1.9521 8.8257-9.7904 0-7.8405-11.033-15.642-11.033-27.373 0-13.008 8.3252-31.437 24.275-33.225 0.28076-0.041 0.5542 0.10035 0.6665 0.34437 0.10986 0.24402 0.0293 0.5268-0.19775 0.68644-4.0601 2.3034-6.687 6.2897-7.0557 10.714 0 23.46 50.759 31.278 50.759 70.375 0 29.323-33.105 31.278-44.138 31.278z",
    fill: "#ccc"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.21234 0 0 .21234 -6.8841 3.6483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.07 317.79-57.346-33.939v-61.051c0-4.267-3.459-7.726-7.726-7.726s-7.726 3.459-7.726 7.726v61.051l-54.175 32.063c-3.673 2.173-4.887 6.912-2.714 10.584 1.443 2.438 4.016 3.792 6.657 3.792 1.338 0 2.693-0.348 3.928-1.078l54.03-31.978 57.202 33.854c1.235 0.731 2.59 1.078 3.928 1.078 2.641 0 5.214-1.355 6.657-3.792 2.173-3.672 0.958-8.411-2.715-10.584z",
    fill: "#efecef"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 116.55,
    r: 116.55,
    fill: "#62a4fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.24 20.652c13.018 18.811 20.652 41.634 20.652 66.243 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.243-20.652 21.035 30.395 56.139 50.31 95.901 50.31 64.37 0 116.55-52.182 116.55-116.55 1e-3 -39.762-19.915-74.866-50.31-95.901z",
    fill: "#5392f9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 74.927,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 116.55c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.151-19.216-42.105-31.317-69.888-31.317z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 395.45,
    cy: 395.45,
    r: 116.55,
    fill: "#b3e59f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.69 299.55c13.018 18.811 20.652 41.634 20.652 66.242 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.242-20.652 21.035 30.395 56.139 50.31 95.901 50.31 64.37 1e-3 116.55-52.181 116.55-116.55 0-39.762-19.916-74.866-50.31-95.901z",
    fill: "#95d6a4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 395.45,
    cy: 353.82,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.45 395.45c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.151-19.216-42.105-31.317-69.888-31.317z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 116.55,
    cy: 395.45,
    r: 116.55,
    fill: "#e27f86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.8 299.55c13.018 18.811 20.652 41.634 20.652 66.242 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.243-20.652 21.036 30.395 56.14 50.311 95.902 50.311 64.37 0 116.55-52.182 116.55-116.55 0-39.762-19.916-74.866-50.311-95.901z",
    fill: "#df646e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.55,
    cy: 353.82,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.55 395.45c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.152-19.216-42.105-31.317-69.888-31.317z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasDeactivatedShared);
export default __webpack_public_path__ + "static/media/gas_deactivated-shared.3bb17a74cd65508606a8a6bf619a73bf.svg";
export { ForwardRef as ReactComponent };